import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Read from "@/pages/Read";
import Admin from "@/pages/Admin";
import Clearance from "@/pages/Clearance";
import NotFound from "@/pages/NotFound";
import { SecretsProvider, useSecrets } from "@/context/SecretsContext";
import { StoreProvider } from "@/context/StoreContext";
import { AnomalyListeners } from "@/components/secrets/AnomalyListeners";
import { MemorialLights, NullSixBlackout } from "@/components/secrets/Overlays";
import { AnomalyOverlayHost } from "@/components/secrets/AnomalyOverlayHost";
import { useVisitTracker } from "@/hooks/use-visit-tracker";

const Shell = () => {
  const { glitchPhase } = useSecrets();
  useVisitTracker();
  return (
    <div className={glitchPhase === "jitter" ? "site-jitter" : undefined}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/read" element={<Read />} />
        <Route path="/clearance" element={<Clearance />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <AnomalyListeners />
      <AnomalyOverlayHost />
      <MemorialLights />
      <NullSixBlackout />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SecretsProvider>
          <StoreProvider>
            <Shell />
          </StoreProvider>
        </SecretsProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
